import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {TrackingService} from "@lcms/shared/data-access-tracking";
import {BehaviorSubject, from, map, startWith, switchMap, tap} from "rxjs";
import {observeProperty} from "@lcms/shared/data-access-user";
import {EditModeService} from "@lcms/shared/edit-mode";
import {FavoritesServiceService} from "@lcms/shared/favorites";
import {NgxShimmerLoadingModule} from "ngx-shimmer-loading";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'lcms-ressource-viewer',
  standalone :true,
  imports : [CommonModule , TranslateModule , NgxShimmerLoadingModule],
  templateUrl: './ressource-viewer.component.html',
  styleUrls: ['./ressource-viewer.component.scss'],
})
export class RessourceViewerComponent  {
  @Input() cmpData: any;
  @Output() changeProgession=new EventEmitter<any>();
  trackingservice: TrackingService = inject(TrackingService);
  updatedTracking = new BehaviorSubject<any>(null);
  updatedTracking$ = this.updatedTracking.asObservable();
  cmpData$ = observeProperty(this as RessourceViewerComponent, 'cmpData');
  newCmpData$ = this.updatedTracking$.pipe(

    startWith(null), // start with a null value to trigger the switchMap initially
    switchMap((ressourceId) => {
      console.log(ressourceId)
      if (ressourceId !== null) {
        // If there's updated data, use it
        return this.trackingservice.getTracking({
          items:[ {type: 'resource',id:ressourceId}]
        }).pipe(
          map(res=>res[0])
          );
        } else {
          // If starting (i.e., updatedData is null), use the initial cmpData$
        return this.cmpData$;
      }
    }),
    tap((dt:any)=>(console.log('new cmo ttttdd',dt)))
  );
  editModeService = inject(EditModeService);
  favoriteService = inject(FavoritesServiceService)
  likedEvent=new EventEmitter()
  btnClass =
    "btn btn-icon btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px bg-light rounded-circle";
  isEditMode$ = this.editModeService.isEditMode$;
  isLoading$ = this.favoriteService.isLoadingAction$$;
  isFavoriteUrl$ = this.favoriteService.favoriteList$.pipe(
    // tap(fav=>console.log(fav)),
    map(list=> list.find((f: any)=>f.url === '/player/' + this.cmpData?.metas?.slug) || null),
  )
  isRating$  = from(this.likedEvent).pipe(
    switchMap((payload : any)=>{

      return   this.favoriteService.likeSet(payload).pipe(
        map((data)=>{
          this.cmpData.likes_count = data.data.likes_count
          this.cmpData.liked = data.data.liked
          return data.data
        })
        ,
        map(() => false)
      )
    })
  )
  addFavorite(ressource:any): void {
    const payload: any = {
      name: ressource.metas?.title,
      icon: 'fa fa-',
      type: 'ressource',
      url: '/player/' + ressource?.metas?.slug
    }
    this.favoriteService.addAction$$.next(payload);
  }
  ngOnChanges(): void {

      const id = this.cmpData?.id;
      if (id) {
        this.updatedTracking.next(id);
      }

  }
  removeFavorite(item:any): void {
    this.favoriteService.deleteAction$$.next(item);
  }
  addLike(ressource : any){
    this.cmpData.liked = true
    const  payload = {
      ressource_id: ressource.id,
      rating: 1
    }
    this.likedEvent.emit(payload)
  }
  deletLike(ressource :any){
    this.cmpData.liked = false
    const  payload = {
      ressource_id: ressource.id,
      rating: 0
    }
    this.likedEvent.emit(payload)
  }
  openPlayerWindow(ressource:any){
    let newWindow : any
    if (ressource._type ==="screen") {
       newWindow  = window.open(`/player/${ressource?.slug}?screen=${ressource.screen}`, '_blank');
    }else {
      newWindow  = window.open(`/player/${ressource?.slug}`, '_blank');
    }

    if (newWindow) {
      let trackingInterval: number | null = null;
      // console.log('Tracking started')
      const startTracking = () => {
        // Update tracking every 6 seconds
        trackingInterval = window.setInterval(() => {
          // console.log('start Tracking')
          this.updatedTracking.next(ressource?.id);
        }, 6000);
      };

      const stopTracking = () => {
        if (trackingInterval !== null) {
          console.log('end Tracking')
          window.clearInterval(trackingInterval);
          trackingInterval = null;
        }
        console.log('Player window closed');
      };

      startTracking();

      // Check regularly if the window has been closed
      const windowClosedCheckInterval = window.setInterval(() => {
        if (newWindow.closed) {
          stopTracking();
          window.clearInterval(windowClosedCheckInterval);
        }
      }, 1000);
    } else {
      // Handle the case when the new window failed to open
      console.log('Failed to open player window');
    }
  }

}
